import { useEffect, useRef } from 'react'
import { useCameraStore } from './useCamera'
import { startFaceTracker } from './FaceTracker'
import { startHandTracker } from './HandTracker'
import { useHeadStore } from '../store/headStore'
import { useHandStore } from '../store/handStore'
import { cubeWorldPosRef } from '../scene/cubeWorldPos'

/**
 * 一个非渲染组件：监听 cameraStore.granted，启动两个 Mediapipe 任务；
 * camera 被停止时清理。
 */
export function CameraDriver() {
  const status = useCameraStore((s) => s.status)
  const video = useCameraStore((s) => s.videoEl)
  const faceStopRef = useRef<(() => void) | null>(null)
  const handStopRef = useRef<(() => void) | null>(null)

  useEffect(() => {
    let cancelled = false

    async function spinUp() {
      if (status !== 'granted' || !video) return
      try {
        const face = await startFaceTracker(video)
        if (cancelled) {
          face()
          return
        }
        faceStopRef.current = face
      } catch (err) {
        // 不阻断站点，但记录到 console
        console.warn('FaceTracker failed:', err)
        useHeadStore.getState().setActive(false)
      }
      try {
        const hand = await startHandTracker(video, () => {
          const p = cubeWorldPosRef.current
          return [p.x, p.y, p.z]
        })
        if (cancelled) {
          hand()
          return
        }
        handStopRef.current = hand
      } catch (err) {
        console.warn('HandTracker failed:', err)
        useHandStore.getState().setActive(false)
      }
    }

    spinUp()

    return () => {
      cancelled = true
      faceStopRef.current?.()
      handStopRef.current?.()
      faceStopRef.current = null
      handStopRef.current = null
      useHeadStore.getState().setActive(false)
      useHandStore.getState().setActive(false)
    }
  }, [status, video])

  return null
}
